import { API_BASE_URL } from '../../envConfig'

import { client } from '../moovyAxiosClient'
import { InitiatePaymentRequestDTO } from './dto'

const apiUrl = `${API_BASE_URL}/v1`

const createPaymentSession = (request: InitiatePaymentRequestDTO) => {
  return client.post(`${apiUrl}/pay`, request)
}

export default {
  createPaymentSession,
}
